import React from "react";

function BatchCancellation () {

    return(
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col">
                        <table className="table mt-3">
                            <thead className="text-center">
                                <tr>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Folio</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Master</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>House</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Fecha y hora</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Cliente</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Monto total</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>UUID Referenciado</th>
                                    <th style={{ backgroundColor: '#020C41', color: 'white' }}>Acciones</th>
                                </tr>
                            </thead>
                            <tbody className="text-center">
                                <tr>
                                    <td colSpan={8}>No hay datos sin facturar</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    );
}

export default BatchCancellation;